import Bugsnag, { NotifiableError } from '@bugsnag/js';

export class ErrorReport {
  public static notify(e: NotifiableError): void {
    try {
      Bugsnag.notify(e);
    } catch {
      // Do nothing
    }
  }
}
